import { Component, Input } from '@angular/core';
import { ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageService } from '../../../../../core/services/language.service';
import { DropdownComponent } from '../../../../../osp-ui/components/form/dropdown/dropdown.component';
import { ErrorComponent } from '../../../../../osp-ui/components/form/form-field/components/error/error.component';
import { LabelComponent } from '../../../../../osp-ui/components/form/form-field/components/label/label.component';
import { FormFieldComponent } from '../../../../../osp-ui/components/form/form-field/form-field.component';
import { BatteryStatus } from '../../../../../shared/enums/battery-status.enum';
import { AlarmSettingsFieldData } from '../../../contract/alarm-settings-field-data.contract';
import { AlarmSettingsBase } from '../alarm-settings-base.class';

@Component({
  selector: 'osp-tracker-battery-alarm-status',
  templateUrl: './tracker-battery-status.component.html',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    DropdownComponent,
    TranslateModule,
    FormFieldComponent,
    LabelComponent,
    ErrorComponent,
  ],
})
export class TrackerBatteryStatusAlarmComponent extends AlarmSettingsBase {
  protected readonly batteryStatuses = [
    { value: BatteryStatus.CRITICAL, label: this.translate('modules.equipment.telematics.critical') },
    { value: BatteryStatus.LOW, label: this.translate('modules.equipment.telematics.low') },
  ];

  constructor(private languageService: LanguageService) {
    super();
  }

  @Input() set form(form: UntypedFormGroup) {
    this.settingsForm = form;
  }

  @Input() set fieldData(fieldData: AlarmSettingsFieldData) {
    this.alarmSettingsFieldData = fieldData;
  }

  private translate(key: string): string {
    return this.languageService.getInstant(key);
  }
}
